export type QuestionType = "MULTIPLE_CHOICE" | "WHO_AM_I";

export type QuizStatus = "ACTIVE" | "INACTIVE";

export type QuizInfo = {
  quizId: number;
  name: string;
  year: number;
  rules: string;
  status?: QuizStatus;
};

export type BackendOption = {
  id: number;
  answer: string;
  correct: boolean;
};

export type BackendQuestion = {
  id: number;
  quizId: number;
  questionNumber?: number;
  question: string;
  date: string;
  type?: QuestionType;
  category?: string;
  hints?: string[];
  fact?: string;
  options: BackendOption[];
};

// Editor state; options without id are new
export type EditableQuestion = {
  id?: number;
  question: string;
  date: string;
  type: QuestionType;
  category: string;
  hints: string[];
  fact: string;
  options: { id?: number; answer: string }[];
  correctIndex: number | null;
};

export const TYPE_LABELS: Record<QuestionType, string> = {
  MULTIPLE_CHOICE: "Flervalg",
  WHO_AM_I: "Hvem er jeg?",
};

export const WHO_AM_I_CATEGORIES = ["Profet", "Sahaba", "Sted", "Sura", "Hendelse"];

export const MAX_HINTS = 3;
